import { createSignal } from "solid-js";

/**
 * Performance scatter Display Options (PerfSettings), shared by every AdvancedScatter on the page
 * and its expanded copy. Both are persisted by PerfSettings as flat user-setting keys.
 */

/** Fits ON: every scatter draws its fit lines. OFF: only the expanded chart does (unless highlighting). */
const [showScatterFits, setShowScatterFits] = createSignal<boolean>(false);

/**
 * "Highlight Fits & Targets" display mode: the advanced scatter shrinks and fades its points
 * (HIGHLIGHT_LINES_POINT_SCALE / _ALPHA) and thickens the fit, target and baseline curves so the
 * lines read first. Does not turn fits on: with Fits OFF only the target and baselines are drawn —
 * on the expanded chart too — and its side table lists those curves instead of the fits.
 */
const [highlightScatterLines, setHighlightScatterLines] = createSignal<boolean>(false);

export const performanceDisplayStore = {
  showScatterFits, setShowScatterFits,
  highlightScatterLines, setHighlightScatterLines,
  clear(): void {
    setShowScatterFits(false);
    setHighlightScatterLines(false);
  },
};
